import request from '@/utils/request'

const basePath = "/api/enterprise/job/collect";

/**
 * 新增职位收藏
 * @param jobPositionId 职位ID
 */
export function saveJobCollection(jobPositionId) {
    return request({
        url: `${basePath}/job/${jobPositionId}`,
        method: 'post'
    });
}

/**
 * 取消职位收藏
 * @param jobPositionId 职位ID
 */
export function cancelJobCollection(jobPositionId) {
    return request({
        url: `${basePath}/job/${jobPositionId}`,
        method: 'delete'
    });
}

/**
 * 删除职位收藏
 * @param id 收藏ID
 */
export function deleteJobCollection(id) {
    return request({
        url: `${basePath}/${id}`,
        method: 'delete'
    });
}

/**
 * 批量删除
 * @param params {ids: **,**,**}
 */
export function batchDeleteJobCollection(params) {
    return request({
        url: `${basePath}/batch`,
        method: 'delete',
        params: params
    });
}

/**
 * 获取职位分页列表
 * @param params {enterpriseName: '', jobName: '', pageNumber: 1, pageSize: 10}
 */
export function getJobCollectionPageList(params) {
    return request({
        url: `${basePath}/`,
        method: 'get',
        params: params
    });
}

/**
 * 检查当前用户是否已收藏该职位
 * @param jobPositionId 职位ID
 */
export function checkJobPositionCollection(jobPositionId) {
    return request({
        url: `${basePath}/check/${jobPositionId}`,
        method: 'get'
    });
}


